module.exports = __webpack_public_path__ + "r-v3/img/emoti-laugh.d5978575.svg";